<div class="p-4">
  <p-card header="Email Campaign Manager">
    <div class="flex justify-content-between align-items-center mb-4">
      <div>
        <h2 class="m-0">Campaigns</h2>
        <p class="text-600 mt-2 mb-0">Manage email campaigns used by the system.</p>
      </div>
      <button pButton type="button" label="New Campaign" icon="pi pi-plus" (click)="openCreateDialog()"></button>
    </div>

    <p-table [value]="campaigns" [responsiveLayout]="'scroll'">
      <ng-template pTemplate="header">
        <tr>
          <th>ID</th>
          <th>Emails</th>
          <th>Delay</th>
          <th>Stop on Response</th>
          <th>Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-campaign>
        <tr>
          <td>{{ campaign.campaignId }}</td>
          <td>{{ campaign.numberOfEmails }}</td>
          <td>{{ campaign.timeBetweenEmails }}</td>
          <td>
            <i class="pi"
              [ngClass]="campaign.killSequenceOnResponse ? 'pi-check-circle text-green-500' : 'pi-times-circle text-red-500'"></i>
          </td>
          <td>
            <button pButton type="button" class="p-button-text" icon="pi pi-pencil"
              (click)="openEditDialog(campaign)"></button>
            <button pButton type="button" class="p-button-danger p-button-text" icon="pi pi-trash"
              (click)="deleteCampaign(campaign)"></button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-card>

  <p-dialog [(visible)]="dialogVisible" [header]="isEditing ? 'Edit Campaign' : 'Create Campaign'" [modal]="true"
    [style]="{ width: '32rem' }">
    <div class="grid formgrid p-fluid">
      <div class="field col-12">
        <label for="numberOfEmails">Number of Emails</label>
        <p-inputNumber inputId="numberOfEmails" [(ngModel)]="form.numberOfEmails" [min]="1"></p-inputNumber>
      </div>
      <div class="field col-12">
        <label for="timeBetweenEmails">Time Between Emails</label>
        <p-inputNumber inputId="timeBetweenEmails" [(ngModel)]="form.timeBetweenEmails" [min]="1"></p-inputNumber>
      </div>
      <div class="field col-12">
        <label>Template Sequence</label>

        <div class="flex align-items-center gap-2 mb-3">
          <p-dropdown [options]="templates" optionLabel="name" optionValue="id" [(ngModel)]="templateIdToAdd"
            [filter]="true" placeholder="Select a template to add" styleClass="flex-grow-1">
          </p-dropdown>
          <button pButton type="button" icon="pi pi-plus" label="Add" [disabled]="!templateIdToAdd"
            (click)="addToSequence()">
          </button>
        </div>

        <p-orderList [value]="sequenceItems" [dragdrop]="true" [listStyle]="{ height: '250px' }"
          header="Send order (top = sent first)">
          <ng-template let-item pTemplate="item">
            <div class="flex justify-content-between align-items-center w-full">
              <span [class.text-500]="item.isOrphan">
                {{ item.label }}
              </span>
              <button pButton type="button" icon="pi pi-times" class="p-button-text p-button-danger p-button-sm"
                (click)="removeFromSequence(item); $event.stopPropagation()">
              </button>
            </div>
          </ng-template>
        </p-orderList>
      </div>
      <div class="field col-12 flex align-items-center gap-2">
        <p-checkbox [(ngModel)]="form.killSequenceOnResponse" binary="true"
          inputId="killSequenceOnResponse"></p-checkbox>
        <label for="killSequenceOnResponse">Kill sequence on response</label>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <button pButton type="button" label="Cancel" class="p-button-text" (click)="dialogVisible = false"></button>
      <button pButton type="button" label="Save" (click)="saveCampaign()"></button>
    </ng-template>
  </p-dialog>
</div>